import { LOAD_SERVICES_STRUCTURE } from '../actions/ServicesStructure';
import { TServicesStructure } from '../types';


type TLoadServicesStructure = {
    type: typeof LOAD_SERVICES_STRUCTURE;
    payload: { service: TServicesStructure };
};

const reducer = (state: TServicesStructure = null, action: TLoadServicesStructure)  => {
    switch (action.type) {
        case LOAD_SERVICES_STRUCTURE:
            return {
                ...state,
                ...action.payload.service,
            };
        default:
            return state;
    }
};


export default reducer;
